import { pageItemsClient } from "@core/clients";
import { ProductShelvesSection } from "@core/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { PAGE_ITEMS_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";

const useGetPageItemByIdQuery = (id: string, options?: UseQueryOptions<ProductShelvesSection | null, any, ProductShelvesSection | null, any>) => {
  return useQuery({
    queryKey: ["pageItemById", id],
    queryFn: () => pageItemsClient.getPageItemById(id),
    cacheTime: PAGE_ITEMS_QUERY_CACHE_EXPIRE_TIME_MS,
    staleTime: PAGE_ITEMS_QUERY_CACHE_EXPIRE_TIME_MS,
    ...options,
  });
};

export default useGetPageItemByIdQuery;